import React from "react"
import Layout from "../components/layout"
import ProjectTile from "../components/ProjectTile"
import ProjectListing from "../components/ProjectListing"
import { graphql } from "gatsby"
import { Helmet } from "react-helmet"


export default ({ data }) => (
    <Layout title="my work">
        <section id="portfolio" className="two">
            <div className="container">

                {/* todo: add alt to all the images */}
                <ProjectListing
                    perColumn={2} >
                    {data.allProjectdataJson.nodes.map((row, i) =>
                        <ProjectTile
                            key={i}
                            title={row.title}
                            image={row.image}
                            page={row.page}
                            desc={row.desc} />
                    )}
                </ProjectListing>

            </div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Apps</title>
                <link rel="canonical" href="https://naxrohan.github.io/apps/" />
            </Helmet>
        </section>
    </Layout>
)

export const result =  graphql`
        query {
        allProjectdataJson {
                nodes {
                    title
                    link
                    page
                    image
                }
            }
        }
    `
// console.log(data)